export default {"en-US": __webpack_public_path__ + "i18n/en-US.c9806f8f.i18next.json"};